<app-chart   *ngIf='openChart' (onCloseChartToParent)='closeChartModals()' [ChartData]="ChartData" [subTitle]="subTitle" [universalAuditID]="universalAuditID"
[component]="component"></app-chart>
<div id="leftdivavl" class="leftdiv">
<span id="spandrpavl" nglDropdown [(open)]="plusDropDownState">
  <section class="overAuditGrid">&nbsp;
      <div id="leftcontrolavl" class="leftControls">
          <span id="spancrlavl" class="cvt-primary rv-new-audit cvt-icon-addCircleFilled"
            nglDropdownTrigger></span>
      </div>
      <div id="leftdivdrpavl"
          class="slds-dropdown slds-dropdown--left rvrs-drpdwn k-primary ">
          <ul class="" role="menu">
              <li id="liidavl" class="" *ngFor="let item of auditCreateMapping;">
                  <a id="anchridavl" [routerLink]="[item.path]" role="menuitem"
                      (click)="plusDropDownState=false;">
                      <p id="pidavl" class="slds-truncate rvrs-para">{{item.text}}</p>
                  </a>
              </li>
          </ul>
      </div>
  </section>
</span>
</div>
<div>   <app-alert></app-alert></div>
    <div class="auditGrid">

    <kendo-grid [data]="view"
    [pageSize]="state.take"
    [skip]="state.skip"
    [sort]="state.sort"
    [sortable]="true"
    [pageable]="{buttonCount: 5,info:norecords}"
    [scrollable]="'none'"
    [selectable]="true"
    [selectedKeys]="selectedAudit"
    [kendoGridSelectBy]="'AuditScheduleID'"
    (selectionChange)="selectionChange($event)"
    (dataStateChange)="dataStateChange($event)"
    >

      <kendo-grid-column title="" [width]="100">
          <ng-template kendoGridHeaderTemplate  let-column>
              &emsp;<span *ngIf='isSuperUser'>&emsp;&nbsp;</span>
            </ng-template>
  <ng-template kendoGridCellTemplate let-rowIndex="rowIndex" let-dataItem>
          <div class="raui-grid-buttons ">
            <a *ngIf="dataItem.Status == 1 " src="#" title="Pending"><span class="cvt-icon-dateTimeQuestion grid-cmd-icons"></span></a>
            <img *ngIf="dataItem.Status == 2" src="../../../assets/download.gif" [width]="33" title="Audit Processing" />
            <!-- <a *ngIf="dataItem.Status == 5 || dataItem.Status == 7" src="#" title="Click to approve to run audit"><span class="cvt-icon-checkIn grid-cmd-icons"></span></a> -->
            <a *ngIf="dataItem.Status == 6" src="#" title="Audit Scheduled to process on  {{dataItem.ProcessAuditWhen|date: 'short'}}"><span class="cvt-icon-countdown grid-cmd-icons"></span></a>
            <a *ngIf="dataItem.Status == 3" src="#" title="Audit Completed"><span class="cvt-icon-completed grid-cmd-icons"></span></a>
            <a *ngIf="dataItem.Status == 4 " src="#"  title="Error running Audit"><span class="cvt-icon-error grid-cmd-icons"></span></a>
            <a *ngIf="(!isSuperUser && ([6,1].includes(dataItem.Status) )) || isSuperUser" src="#" title="Delete Audit" (click)="onDelete(dataItem.AuditID)"><span class="cvt-icon-trash grid-cmd-icons"></span></a>

<!--
                      <div class="raui-grid-buttons">
                        <a *ngIf="dataItem.Status == 1 " src="#" title="Pending"><span class="cvt-icon-dateTimeQuestion grid-cmd-icons"></span></a>
                        <img  *ngIf="dataItem.Status == 2" src="../../../assets/download.gif" [width]="33" title="Running"/>
                        <a *ngIf="dataItem.Status == 3 " src="#" ><span class="cvt-icon-completed grid-cmd-icons"  title="Audit Completed"></span></a>
                        <a *ngIf="dataItem.Status == 4 " src="#"  title="Error running Audit"><span class="cvt-icon-error grid-cmd-icons"></span></a>
                        <a *ngIf="dataItem.Status == 5 || dataItem.Status == 7"  src="#" title="Click to approve to run audit"><span class="cvt-icon-checkIn grid-cmd-icons" (click)="approveAuditToRun(dataItem.AuditID)"></span></a>
                        <a *ngIf="dataItem.Status == 6 || dataItem.Status == 8"  src="#" title="Audit Scheduled to process on  {{dataItem.ScheduledRunDate|date: 'short'}}"><span class="cvt-icon-countdown grid-cmd-icons"></span></a>
                    </div>

 -->

          </div>
        </ng-template>
      </kendo-grid-column>
      <kendo-grid-column field="JobID" title="Audit ID" >
        <ng-template kendoGridHeaderTemplate let-column>
          <span>{{column.title}} </span>&emsp;<img *ngIf="this.sorted !== column.field" style="margin-bottom: -5px;" src="../../../assets/sort-button.png"
          />
        </ng-template>
        <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
         <div >{{ dataItem.JobID }}</div>
        </ng-template>
      </kendo-grid-column>
      <kendo-grid-column  title="" [width]="180" >
          <ng-template kendoGridHeaderTemplate  let-column>
              &emsp;&emsp;<span >&emsp;&emsp;&nbsp;</span>
            </ng-template>
   <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
          <div class="raui-grid-buttons ">
            <a *ngIf="dataItem.Status == 6" class="cvt-icon-edit grid-cmd-icons edit-audit-icon" title="Edit Audit"
           (click)="onOpenEditModal(dataItem.AuditID,dataItem.Name,dataItem.ProcessAuditWhen,dataItem.AuditNotificationID,dataItem.AuditScheduleID)" ></a>
            <a src="#" title="View Chart"><span class="cvt-icon-reports grid-cmd-icons" (click)="onDisplayChart(dataItem.AuditScheduleID,dataItem.JobID)"></span></a>
            <a  title="Report(s)" [routerLink]="['../rv-report', {auditId:dataItem.AuditID,scheduleId:dataItem.AuditScheduleID}]" ><span class="cvt-icon-document grid-cmd-icons"></span></a>
            <a [routerLink]="['../review', {auditId:dataItem.auditID, universalId:dataItem.JobID, accountName:dataItem.Name, scheduleId:dataItem.AuditScheduleID}]"  title="Notification"><span class="cvt-icon-htmlEmail grid-cmd-icons"></span></a>
          </div>
        </ng-template>
      </kendo-grid-column>
      <kendo-grid-column field="NameUpperCase" title="Audit Name" >
        <ng-template kendoGridHeaderTemplate let-column>
          <span>{{column.title}}</span>&emsp;<img *ngIf="this.sorted !== column.field" style="margin-bottom: -5px;" src="../../../assets/sort-button.png" />
        </ng-template>
         <ng-template kendoGridCellTemplate let-dataItem>
          {{ dataItem.Name }}
        </ng-template>
      </kendo-grid-column>
      <kendo-grid-column field="RACFilters" title="Rate Access Code Filter" >
        <ng-template kendoGridHeaderTemplate let-column>
          <span>{{column.title}}</span>&emsp;<img *ngIf="this.sorted !== column.field" style="margin-bottom: -5px;" src="../../../assets/sort-button.png"
          />
        </ng-template>
          <ng-template kendoGridCellTemplate let-dataItem>
            <div title= "{{ dataItem.RACFilters }}"  class="setMaxWidth"> {{ dataItem.RACFilters }} </div>
        </ng-template>
      </kendo-grid-column>
      <kendo-grid-column field="PlacedOnQueue" title="Audit Created" >
        <ng-template kendoGridHeaderTemplate let-column>
          <span>{{column.title}}</span>&emsp;<img *ngIf="this.sorted !== column.field" style="margin-bottom: -5px;" src="../../../assets/sort-button.png"
          />
        </ng-template>
        <ng-template kendoGridCellTemplate let-dataItem>
         <div class="setDateWidth">{{ dataItem.PlacedOnQueue | dateBlank:'medium' }}</div>
        </ng-template>
      </kendo-grid-column>

       <kendo-grid-column field="ProcessAuditWhen" title="Audit Scheduled" >
        <ng-template kendoGridHeaderTemplate let-column>
          <span>{{column.title}}</span>&emsp;<img *ngIf="this.sorted !== column.field" style="margin-bottom: -5px;" src="../../../assets/sort-button.png"
          />
        </ng-template>
        <ng-template kendoGridCellTemplate let-dataItem>
          <div class="setDateWidth" [innerText]="dataItem.ProcessAuditWhen | dateBlank " ></div>
        </ng-template>
      </kendo-grid-column>

        <kendo-grid-column field="AuditJobCompleted" title="Audit Completed" >
        <ng-template kendoGridHeaderTemplate let-column>
          <span>{{column.title}}</span>&emsp;<img *ngIf="this.sorted !== column.field" style="margin-bottom: -5px;" src="../../../assets/sort-button.png"
          />
        </ng-template>
        <ng-template kendoGridCellTemplate let-dataItem>
          <div class=setDateWidth [innerText]="dataItem.AuditJobCompleted | dateBlank"></div>
           <!-- {{ dataItem.AuditJobCompleted |date:'medium' }} -->
        </ng-template>
      </kendo-grid-column>
        <kendo-grid-column field="AuditNotificationName" title="Assigned Notification Template" >
        <ng-template kendoGridHeaderTemplate let-column>
          <span>{{column.title}}</span>&emsp;<img *ngIf="this.sorted !== column.field" style="margin-bottom: -5px;" src="../../../assets/sort-button.png"
          />
        </ng-template>
         <ng-template kendoGridCellTemplate let-dataItem>
         <div title="{{ dataItem.AuditNotificationName }}" class="setMaxWidth">{{ dataItem.AuditNotificationName }}</div>
        </ng-template>
      </kendo-grid-column>
    </kendo-grid>
  </div>
  <div kendoDialogContainer *ngIf='kendoDialog' ></div>
  <div kendoDialogContainer *ngIf='rv_kendoDialog' ></div>

  <app-modal (onOkToParent)='okButtonClick()'   (onCloseToParent)='closeModals()' *ngIf='openModal'
  [dialogTitle]="dialogTitle"
  [dialogTextLine1]="dialogTextLine1"
  [dialogTextLine2]="dialogTextLine2"
  [primaryButtonText]="primaryButtonText"
  [secondaryButtonText]="secondaryButtonText"
  ></app-modal>


  <app-rvmodal (onrvOkToParent)='rv_okButtonClick()'    (onrvCloseToParent)='rv_closeModals()' *ngIf='rv_openModal'
  [dialogTitle]="rv_dialogTitle"
  [primaryButtonText]="rv_primaryButtonText"
  [secondaryButtonText]="rv_secondaryButtonText"
  [auditID]="auditID"
  [auditName]="auditName"
  [auditProcessedWhen]="auditProcessedWhen"
  [AuditNotificationID]="AuditNotificationID"
  [AuditScheduleID]="AuditScheduleID"
  ></app-rvmodal>
